import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Tags from "./Tags"
import AuthorAvatar from "./AuthorAvatar"
import { analyticsAction } from "/src/utils/analytics"

function NewsArticle(post) {
  const siteSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          slugs {
            blog
          }
        }
      }
    }
  `)

  const { title, custom_excerpt, featureImage, slug, tags } = post.node
  const feature_image = getImage(featureImage)
  const { slugs } = siteSettings.site.siteMetadata

  return (
    <article className="flex flex-col h-full" data-aos="fade-up">
      {/* Article template */}
      <header>
        <Link className="block mb-6" to={`${slugs.blog}/${slug}/`}>
          <figure className="relative h-0 pb-9/16 overflow-hidden rounded-md">
            <GatsbyImage
              className="absolute inset-0 object-cover transform hover:scale-105 transition duration-700 ease-out"
              imgClassName=""
              image={feature_image}
              alt={title}
            />
          </figure>
        </Link>
        <div className="mb-3">
          <Tags {...{ tags }} />
        </div>
        <h3 className="h4 mb-2">
          <Link
            className="hover:text-gray-100 transition duration-150 ease-in-out"
            to={`${slugs.blog}/${slug}/`}
            onClick={() => analyticsAction("landing_blog_post_click")}
          >
            {title}
          </Link>
        </h3>
      </header>

      <p className="text-lg text-gray-400 flex-grow">{custom_excerpt}</p>

      <footer className="flex items-center mt-4">
        <AuthorAvatar {...{ data: post.node }} />
      </footer>
    </article>
  )
}

export default NewsArticle
